import React, {useContext, useEffect, useRef, useState} from 'react';
import {motion, useReducedMotion} from "framer-motion";
import {useSelector} from 'react-redux';
import styles from './AdminMenu.module.scss';
import {useNavigate} from 'react-router-dom';
import Button from "../../../elements/Button/Button";
import {menuVariants} from "../../../../utilities/framerVariants";
import {AppContext} from "../../../../context/AppContext";

const AdminMenu = () => {
    const {isAdmin} = useContext(AppContext);
    const {loading} = useSelector((state) => state.profile);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const navigate = useNavigate();
    const shouldReduceMotion = useReducedMotion();
    const containerRef = useRef(null);

    const variant = (element) => {
        return shouldReduceMotion
            ? menuVariants.reduced
            : menuVariants[element];
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleOutsideClick = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
        }
    };

    useEffect(() => {
        if (isDropdownOpen) {
            document.addEventListener('click', handleOutsideClick);
        } else {
            document.removeEventListener('click', handleOutsideClick);
        }
        return () => document.removeEventListener('click', handleOutsideClick);
    }, [isDropdownOpen]);

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <>
            {isAdmin && (
                <div className={styles.adminMenu} ref={containerRef}>
                    <Button
                        className={styles.menuButton}
                        onClick={toggleDropdown}
                        aria-expanded={isDropdownOpen}
                    >
                        Admin Menu
                    </Button>

                    {isDropdownOpen && (
                        <motion.div
                            className={styles.dropdownContainer}
                            variants={variant('menu')}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                        >
                            <ul className={styles.dropdown}>
                                <li onClick={() => navigate('/register')}>Register</li>
                                <li onClick={() => navigate('/customer')}>Update Info</li>
                                <li onClick={() => navigate('/users')}>Users</li>
                            </ul>
                        </motion.div>
                    )}
                </div>
            )}
        </>
    );
};

export default AdminMenu;
